module.exports = __webpack_public_path__ + "media/images/logo-white-fd2b11c050fba9e87c64138a70601289.svg";